import type { StateStorage } from 'zustand/middleware';

// localStorage adapter that prefixes the storage key with the current Clerk
// userId. Prevents cross-contamination when multiple users sign in on the same
// browser. Falls back to a no-op if Clerk isn't ready yet — the persist
// middleware should be triggered to rehydrate once Clerk loads (see
// FilterStoresRehydrator in apps/web/pages/_app.tsx).
function getUserId(): string | null {
  if (typeof window === 'undefined') return null;
  const clerk = (window as unknown as { Clerk?: { user?: { id?: string } } }).Clerk;
  return clerk?.user?.id ?? null;
}

function scopedKey(name: string, userId: string): string {
  return `${name}.${userId}`;
}

export const userScopedStorage: StateStorage = {
  getItem: (name) => {
    if (typeof window === 'undefined') return null;
    const userId = getUserId();
    if (!userId) return null;
    return window.localStorage.getItem(scopedKey(name, userId));
  },
  setItem: (name, value) => {
    if (typeof window === 'undefined') return;
    const userId = getUserId();
    if (!userId) return;
    window.localStorage.setItem(scopedKey(name, userId), value);
  },
  removeItem: (name) => {
    if (typeof window === 'undefined') return;
    const userId = getUserId();
    if (!userId) return;
    window.localStorage.removeItem(scopedKey(name, userId));
  },
};
